<template>
  <v-container class="feature-container">
    <v-row align="center">
      <v-col align="center" cols="12" lg="12" md="12" sm="12" xs="12">
        <h1>{{ this.lg_footer.privacy_policy }}</h1>
      </v-col>
    </v-row>

    <v-row v-if="checklanguage === 'th'" align="center" justify="center" >
      <v-col  cols="12" xl="6" lg="8" md="8" sm="8" xs="10" v-bind:style="{height:'60vh', overflow:'auto' }">
        
        <span style="font-size:16px;" v-html="`<span style='font-weight:bold;'>&ensp;&ensp;&ensp;&ensp; บริษัท ดิจิทัล คอร์ปอเรท เมเนจเม้นท์ จํากัด (DCM)  </span>
        <span> บริษัทในเครือของบริษัท</span> 
        <span style='font-weight:bold;'>เดชอุดม แอนด์ แอสโซ ซิเอทส์ จํากัด </span>
        โดยมี ศาสตราจารย์พิเศษเดชอุดม ไกรฤทธิ์ ประธานเจ้าหน้าที่บริหารและผู้ก่อตั้งบริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จํากัด มีความประสงค์ที่จะรังสรรค์รูปแบบของการเข้าถึงข้อมูลนิติบุคคลของผู้ประกอบธุรกิจ ในประเทศไทย โดยเฉพาะผู้ประกอบธุรกิจขนาดเล็กและขนาดกลาง (SMEs) ให้มีความคล่องตัวทางด้านการ จัดการบริหารงานข้อมูลภายในองค์กรของตนที่สามารถประหยัดเวลาได้อย่างมาก จึงได้คิดและสร้างสรรค์ โปรแกรมการบริหารงานธุรกิจซึ่งในชั้นแรกจะใช้นิติบุคคลในรูปของบริษัทจํากัด โดยได้จัดทํา Application Software ขึ้น ทั้งนี้ได้อาศัยประสบการณ์ในการทํางานเป็นทนายความที่ปรึกษามานานกว่า 30 ปี
          <br><br><span>&ensp;&ensp;&ensp;&ensp; การนําเสนอ Digital Corporate Management ของบริษัท ดิจิทัล คอร์ปอเรท เมเนจเม้นท์ จํากัด ซึ่งจะ ทําหน้าที่เป็นผู้บริหารข้อมูลนั้นจะมีการส่งและรับข้อมูลจากบริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จํากัด ซึ่ง
        บางส่วนอาจเป็นข้อมูลส่วนตัวรวมถึงข้อมูลที่ต้องเปิดเผยโดยทั่วไปที่เป็นส่วนของการจดทะเบียนตามกฎหมาย อย่างไรก็ดี “นโยบายความเป็นส่วนตัว” ของการบริหารข้อมูลของ DCM ยึดหลักการถือปฏิบัติในข้อมูลต่าง ๆ ของ ลูกความบริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จํากัด เป็นความลับเช่นเดียวกับงานในหน้าที่ทนายความที่ปรึกษา กฎหมายของบริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จํากัด</span>
          <br><br><span>&ensp;&ensp;&ensp;&ensp; DCM ได้ใช้ “นโยบายความเป็นส่วนตัว” นี้เพื่ออธิบายวิธีการที่ DCM ใช้รวบรวม เก็บ ประมวลผล เปิดเผยข้อมูลของผู้ใช้ เมื่อผู้ใช้เยี่ยมชม “เว็บไซต์” หรือใช้ “บริการ” ของ DCM “นโยบายความเป็นส่วนตัว” นี้มี ผลกับ “ข้อมูลส่วนบุคคล” ของผู้ใช้เมื่อผู้ใช้เยี่ยมชม “เว็บไซต์” หรือใช้ “บริการ” และไม่มีผลกับเว็บไซต์หรือ บริการออนไลน์ที่ DCM ไม่ได้เป็นเจ้าของหรือควบคุม รวมถึงเว็บไซต์หรือบริการของผู้ใช้ DCM คนอื่น ๆ “นโยบายความเป็นส่วนตัว” นี้ได้รับการออกแบบมาเพื่อช่วยให้ผู้ใช้ได้รับข้อมูลเกี่ยวกับแนวทางปฏิบัติเรื่องความ เป็นส่วนตัวของ DCM และเพื่อช่วยให้ผู้ใช้เข้าใจทางเลือกเกี่ยวกับความเป็นส่วนตัวของผู้ใช้เมื่อท่านใช้ “เว็บไซต์”
        และ “บริการ” ของ DCM</span>
          <br><br><span>&ensp;&ensp;&ensp;&ensp; โปรด “ติดต่อ DCM” ถ้าท่านมีข้อสงสัยเกี่ยวกับแนวทางปฏิบัติเรื่องความเป็นส่วนตัวของ DCM ซึ่งไม่ได้ ระบุไว้ใน “นโยบายความเป็นส่วนตัว”</span>
          <br><br><span style='font-weight:bold;'>1. DCM เก็บรวบรวมข้อมูลส่วนบุคคลอะไรบ้าง </span>  
          <br><br><span>&ensp;&ensp;&ensp;&ensp; DCM อาจเก็บข้อมูลเกี่ยวกับผู้ใช้เมื่อผู้ใช้เยี่ยมชมเว็บไซต์หรือใช้บริการของ DCM ซึ่งรวมถึงข้อมูลการ ลงทะเบียนและข้อมูลการใช้เมื่อผู้ใช้ลงทะเบียนเพื่อใช้บริการของ DCM ด้วยการสร้างบัญชี DCM จะรวบรวม ข้อมูลส่วนบุคคลตามที่ผู้ใช้ร้องขอ ซึ่ง DCM อาจขอให้ผู้ใช้กรอกชื่อบริษัท ที่อยู่ทางไปรษณีย์ หมายเลขโทรศัพท์ อีเมล และข้อมูลระบุของผู้ใช้เพื่อเปิดบัญชี ทั้งนี้ขึ้นอยู่กับบริการที่ผู้ใช้เลือก และ DCM อาจขอให้ผู้ใช้กรอกข้อมูล ส่วนบุคคลเพิ่มเติมในขณะที่ผู้ใช้ใช้บริการของ DCM ซึ่งอาจจะเป็นข้อมูลการทํารายการและประสบการณ์ใช้งาน - เมื่อผู้ใช้ใช้บริการหรือเข้าสู่เว็บไซต์ของ DCM เช่น เพื่อร้องขอเอกสาร เพื่อปรึกษาด้านคดีความ DCM จะเก็บ รวบรวมข้อมูลเกี่ยวกับการทํารายการ ตลอดจนข้อมูลอื่นๆ ที่เกี่ยวข้องกับการทํารายการ เช่น เรื่องที่ร้องขอ เอกสาร หรือเรื่องราวที่ต้องการปรึกษาผู้เชี่ยวชาญของ DCM รวมถึงการเข้าถึงเอกสารและดาวน์โหลดเอกสาร - เมื่อผู้ใช้เข้าถึงเอกสารหรือดาวน์โหลดเอกสารในบริการของ DCM ที่ระบบอาจเก็บข้อมูลการทํารายการของผู้ใช้
        โดยอัตโนมัติ</span> 
          <br><br><span style='font-weight:bold;'>2. การเก็บรักษาข้อมูลส่วนบุคคล </span>
          <br><br><span>&ensp;&ensp;&ensp;&ensp; DCM เก็บรักษาข้อมูลส่วนบุคคลเพื่อให้เป็นไปตามหน้าที่ตามกฎหมายหรือข้อบังคับของ DCM และเพื่อ วัตถุประสงค์ทางธุรกิจของ DCM DCM อาจเก็บรักษาข้อมูลส่วนบุคคลไว้เป็นระยะเวลานานกว่าที่กฎหมาย กําหนดถ้าข้อมูลนั้นยังอยู่ในความต้องการทางธุรกิจ และไม่เป็นการต้องห้ามตามกฎหมาย ถ้าบัญชีของผู้ใช้ถูกปิด DCM อาจดําเนินการตามขั้นตอนเพื่อปกปิดข้อมูลส่วนบุคคลและข้อมูลอื่น ๆ ซึ่ง DCM ขอสงวนสิทธิ์ในการเก็บ รักษาและเข้าถึงข้อมูลตราบใดที่จําเป็นในการปฏิบัติตามกฎหมายที่บังคับใช้ DCM จะยังคงใช้และเปิดเผย “ข้อมูลส่วนบุคคล” ดังกล่าวตาม “นโยบายความเป็นส่วนตัว” ฉบับนี้อย่างเคร่งครัด สําหรับการเก็บรักษาข้อมูล ส่วนบุคคลในรูปแบบเอกสารที่ได้ร้องขอ เป็น pdf บน Server ของ DCM</span>   
          <br><br><span style='font-weight:bold;'>3. การประมวลผลข้อมูลส่วนบุคคล </span>
          <br><br><span>&ensp;&ensp;&ensp;&ensp; DCM อาจประมวลผล ข้อมูลของผู้ใช้เพื่อจัดลําดับความสําคัญของความต้องการในข้อมูลทางธุรกิจของ DCM เช่น การตรวจสอบผู้ใช้งาน ระดับการใช้งาน การวิเคราะห์ และการปรับปรุงบริการ ตลอดจนประสิทธิภาพ และฟังก์ชันการทํางานของเว็บไซต์ ในส่วนของการแจ้งข่าวสารถึงผู้ใช้เป็นครั้งคราว ทั้งนี้ DCM จะทําโดยส่ง ข้อมูลที่จําเป็นเกี่ยวกับการบริหารองค์กร และข้อมูลทางกฎหมายที่ผู้ใช้ควรต้องทราบ ตลอดจนผลิตภัณฑ์และ บริการของธุรกิจที่เกี่ยวข้องกัน นอกจากนี้ DCM ยังอาจประมวลผลข้อมูลของผู้ใช้เพื่อปรับบริการหรือ ประสบการณ์การใช้งานเว็บไซต์เพื่อให้เข้าถึงความเข้าใจในความสนใจของผู้ใช้ได้ดียิ่งขึ้น โดยเฉพาะเพื่อการปฏิบัติ
        ตามหน้าที่ของ DCM และเพื่อบังคับใช้ข้อกําหนดของเว็บไซต์และบริการของ DCM ให้เป็นไปตามกฎหมายและกฎ ข้อบังคับที่ใช้บังคับทั้งในปัจจุบันและอนาคต รวมถึงเพื่อใช้ตอบกลับคําขอของผู้ใช้ เช่น ติดต่อผู้ใช้เกี่ยวกับคําถามที่ ผู้ใช้ส่งมายังฝ่ายบริการของ DCM</span>   
          <br><br><span style='font-weight:bold;'>4. DCM แบ่งปันข้อมูลส่วนบุคคลหรือไม่ </span>
          <br><br><span>&ensp;&ensp;&ensp;&ensp; ในกรณีที่ DCM จําเป็นต้องดําเนินการดังกล่าวเพื่อการปฏิบัติตามกฎหมาย คําสั่งหรือหมายเรียกหรือคํา บังคับหรือหมายบังคับคดีของศาล
        คําสั่งหรือหมายเรียกของพนักงานสอบสวนหรือพนักงานตามกฎหมายอาญา หรือคําสั่งทางปกครองของพนักงานเจ้าหน้าที่ตามกฎหมายที่ DCM หรือบริษัทในเครือของ Dej-Udom &
        Associates Ltd. จําเป็นต้องถือปฏิบัติตามเพื่อให้สอดคล้องกับบทบัญญัติของกฎหมายหรือตามคําสั่งดังกล่าวที่ เกี่ยวข้องกับข้อมูลผู้ใช้บริการของ DCM และเพื่อปกป้องผลประโยชน์ที่สําคัญของบุคคล และเพื่อปกป้องทรัพย์สิน บริการ และการปฏิบัติตามกฎหมายของ DCM DCM จะแจ้งให้ผู้เป็นเจ้าของข้อมูลนั้นทราบทุกครั้ง </span>
          <br><br><span style='font-weight:bold;'>5. การปกป้องข้อมูลส่วนบุคคล </span>
          <br><br><span>&ensp;&ensp;&ensp;&ensp; DCM จัดวางระบบรักษามาตรการความปลอดภัยทางเทคนิค ทางกายภาพ และทางด้านการบริหาร
        จัดการที่ออกแบบมาเพื่อให้ความคุ้มครองที่เหมาะสมสําหรับข้อมูลส่วนบุคคลของผู้ใช้จากการสูญหาย การใช้ ในทางที่ผิด การเข้าใช้โดยไม่ได้รับอนุญาต การเปิดเผย และการเปลี่ยนแปลงแก้ไข มาตรการด้านความปลอดภัย ได้แก่ ไฟร์วอลล์ การเข้ารหัสข้อมูล การควบคุมการเข้าถึงทางกายภาพเมื่อเข้าสู่ศูนย์ข้อมูลของ DCM และการ ควบคุมการอนุญาตให้เข้าถึงข้อมูล ในขณะที่ DCM ให้ความสําคัญต่อการรักษาความปลอดภัยระบบและบริการ ของ DCM ดังกล่าว ผู้ใช้ก็มีหน้าที่รับผิดชอบในการรักษาความปลอดภัยและรักษาความเป็นส่วนตัวของรหัสผ่าน ของผู้ใช้ และตรวจสอบว่าข้อมูลส่วนบุคคลที่ DCM มีเกี่ยวกับผู้ใช้นั้นถูกต้องและเป็นปัจจุบัน DCM จะไม่ รับผิดชอบในการปกป้องข้อมูลส่วนบุคคลใดๆ ที่ DCM เปิดเผยให้บุคคลภายนอกตามที่มีการเชื่อมต่อบัญชีซึ่งผู้
        ใช้ได้ให้อนุญาต </span>
          <br><br><span style='font-weight:bold;'>6. ข้อกําหนดอื่นๆ ที่ผู้ใช้ควรทราบ </span>
          <br><br><span>&ensp;&ensp;&ensp;&ensp; การแก้ไขเปลี่ยนแปลง “นโยบายความเป็นส่วนตัว” ให้สอดคล้องกับวิทยาการเทคโนโลยีและกฎหมาย ใหม่ซึ่งมีผลให้ DCM อาจต้องแก้ไข “นโยบายความเป็นส่วนตัว” นี้เป็นครั้งคราว เพื่อให้รับกับการเปลี่ยนแปลง ของธุรกิจของ DCM บนเว็บไซต์หรือการให้บริการ หรือกฎหมายที่ใช้บังคับต่อ “นโยบายความเป็นส่วนตัว” ตามประกาศฉบับนี้ ดังนั้น หากมีการเปลี่ยนแปลงในสาระสําคัญ DCM จะประกาศให้ผู้ใช้ทราบก่อนล่วงหน้า 30 วัน ด้วยการโพสต์รายละเอียดการเปลี่ยนแปลงในหน้า “การปรับปรุงแก้ไขนโยบาย “ ในเว็บไซต์ของ DCM นอกจากนี้
        DCM อาจแจ้งให้ผู้ใช้ทราบเกี่ยวกับการเปลี่ยนแปลงโดยใช้อีเมลหรือวิธีอื่น </span>
          <br><br><span style='font-weight:bold;'>7. ติดต่อ DCM </span>
          <br><br><span>&ensp;&ensp;&ensp;&ensp; ผู้ใช้สามารถติดต่อ DCM ได้ถ้าผู้ใช้มีคําถามทั่วไปเกี่ยวกับ “นโยบายความเป็นส่วนตัว” และแนวทาง
        ปฏิบัติของ DCM </span>
        <br><br><span>&ensp;&ensp;&ensp;&ensp; คลิกที่นี่เพื่อติดต่อ DCM </span>
        <br><br><span>&ensp;&ensp;&ensp;&ensp; 18 ธันวาคม 2561 </span>
          `">
        </span>
      
      </v-col>
    </v-row>

     <v-row v-else align="center" justify="center" >
      <v-col  cols="12" xl="6" lg="8" md="8" sm="8" xs="10" v-bind:style="{height:'60vh', overflow:'auto' }">
        <span style="font-size:16px;" v-html="`
        <span> At DCM, we respect your privacy and are committed to protecting your personal data. This
Privacy Policy outlines how we collect, use, and share your information when you engage with
our services, including visiting our website or utilizing our business and legal .</span> 
          <br><br><span style='font-weight:bold;'>1. Who We Are </span>  
          <br><br><span>&ensp;&ensp;&ensp;&ensp; Digital Corporate Management Co., Ltd. (DCM), is a part of Dej-Udom & Associates who
provides a broad range of corporate, legal, and digital solutions. We specialize in corporate and
legal advisory, business restructuring, compliance, and digital transformation to help clients
navigate modern business challenges.
</span> 
          <br><br><span style='font-weight:bold;'>2. Personal Data We Collect </span>
          <br><br><span> We may collect the following types of personal data:</span><br><br>
          <ul>
  <li><span style='font-weight:bold;'>Personal Information: </span><span>: Information such as your name, email address, contact details, and any other data you provide when engaging with our services or communicating with us. </span> </li>
  <li><span style='font-weight:bold;'>Location Data Usage: </span>
  <span>Our app collects and uses your location data </span>
  <span style='font-weight:bold;'>only for work-related check-in purposes. </span>
  <span> This ensures accurate attendance tracking by
verifying your location when you check in or check out of your workplace. For example,
when an employee checks in, the app records their location to confirm they are at the
designated worksite, ensuring compliance with company policies. We do not use your
location for any other purpose, and your data is securely processed following privacy
regulations. </span>
work-related check-in purposes. </span>
  <li><span style='font-weight:bold;'>Information from Third Parties: </span>
  <span>Data obtained from third-party services, such as
Google, when using single sign-on options, or from our professional partners and
affiliates. </span>
   </li>
</ul> 
          <br><br><span style='font-weight:bold;'>3. How We Collect Your Data </span>
          <br><br><span>We collect your personal data in the following ways: </span><br><br> 
          <ul>
          <li><span style='font-weight:bold;'>Direct Interactions: </span><span>When you sign up for our services, communicate with us, attend
events, or participate in webinars and virtual meetings. </span></li>
          <li><span style='font-weight:bold;'>Automated Technologies: </span><span>Data collected through cookies or similar technologies when
you engage with our website. </span></li>
 <li><span style='font-weight:bold;'>Third-Party Sources: </span><span>Data from professional colleagues, organizations, or third-party
service providers that collaborate with DCM. </span></li>
          </ul> 
          <br><br><span style='font-weight:bold;'>4. How We Use Your Data </span>
         <br><br><span>We use your personal data to: </span> <br><br>
         <ul>
          <li>
          <span>Provide, improve, and secure our services, ensuring a smooth experience across our
legal and business solutions. </span>
           </li>
           <li>
          <span>Send email newsletters, updates, and other communications relevant to our services
and products </span>
           </li>
             <li>
          <span>Conduct statistical analysis for marketing and business development purposes.
 </span>
           </li>
             <li>
          <span>Support digital transformation and management consulting, offering tailored legal and
corporate advisory services to clients. </span>
           </li>
          </ul> 
          <br><br><span style='font-weight:bold;'>5. How We Share Your Data </span>
           <br><br><span>We may share your data with: </span><br><br>
  <ul>
          <li><span style='font-weight:bold;'>Service Providers: </span><span>Third-party providers that support business functions, including
digital tools, consulting, and marketing services. </span>
 </li>
          <li><span style='font-weight:bold;'>Advertising Networks: </span><span>Partners that help display targeted advertisements across our platforms </span></li>
 <li><span style='font-weight:bold;'>Legal Obligations: </span><span>Courts, law enforcement, or government authorities to comply with
legal requirements or protect the rights and safety of DCM and its clients.
 </span>
 </li>
          </ul> 
          <br><br><span style='font-weight:bold;'>6. Your Rights and Choices </span>
  <br><br><span>You have the right to: </span><br><br>
  <ul>
          <li><span style='font-weight:bold;'>Access and Update: </span><span>Review and update your personal data at any time. </span>
 </li>
          <li><span style='font-weight:bold;'>Opt-out: </span><span>Unsubscribe from email communications by following the instructions in our
emails or contacting us directly. </span>
</li>
          </ul> 

          <br><br><span style='font-weight:bold;'>7. Security of Your Data </span>
          <br><br><span>We implement technical and administrative safeguards to protect your personal data from
unauthorized access or misuse. However, no online data transmission is completely secure, and
users provide information at their own risk </span>

 <br><br><span style='font-weight:bold;'>8. Changes to This Policy </span>
          <br><br><span>We may update this Privacy Policy periodically. Any changes will be communicated directly or
posted on our website.
 </span>

 <br><br><span style='font-weight:bold;'>9. Contact Information </span>
          <br><br><span>For questions or concerns about this Privacy Policy or your personal data, please contact us at:
 </span>

        <br><br><span style='font-weight:bold;'>&ensp;&ensp;&ensp;&ensp; Digital Corporate Management Co., Ltd. </span>
        <br><span>&ensp;&ensp;&ensp;&ensp; Charn Issara Tower I, 2nd Fl., </span>
        <br><span>&ensp;&ensp;&ensp;&ensp; 942/69 Rama IV Road, </span>
        <br><span>&ensp;&ensp;&ensp;&ensp; Bangrak District, Bangkok 10500 </span>
        <br><span>&ensp;&ensp;&ensp;&ensp; Tel: (66) 2233-0055 </span>
        <br><span>&ensp;&ensp;&ensp;&ensp; Email: admin@dcm.co.th </span>
          `">
        </span>
      
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { feature } from "../services/constants";
import { lg_footer } from "./language/lg_footer.js";
export default {
  name: "feature",
  data: () => ({
    width: 420,
    text_fontsize: 30,
    checklanguage:"",
  }),
  methods: {
    onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
  },
  async mounted() {
    this.checklanguage = localStorage.getItem(feature.LANGUAGE);
  },
  async beforeCreate() {
    this.$store.state.page_reload = false;

    // alert(localStorage.getItem("language"))
    // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_footer = lg_footer.lg_footer_th)
      : (this.lg_footer = lg_footer.lg_footer_en);

    // console.log("lg_login: " + JSON.stringify(this.lg_login));
  },
};
</script>

<style>
@media (min-width: 960px) {
  .feature-container {
    margin-top: 3rem
  }
}
</style>
